import { MotionText } from '@shared/atoms';
import { SystemButton } from '@shared/molecules/SystemButton/SystemButton';
import { AnimatePresence, motion } from 'framer-motion';
import React from 'react';
import styles from './index.module.scss';

interface DeleteConfirmDialogProps {
  isOpen: boolean;
  title: string;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
  isDeleting: boolean;
}

export const DeleteConfirmDialog: React.FC<DeleteConfirmDialogProps> = ({
  isOpen,
  title,
  message,
  onConfirm,
  onCancel,
  isDeleting,
}) => (
  <AnimatePresence>
    {isOpen && (
      <motion.div
        className={styles.deleteConfirmOverlay}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={onCancel}
      >
        <motion.div
          className={styles.deleteConfirmDialog}
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.9 }}
          onClick={(e) => e.stopPropagation()}
        >
          <MotionText as="h3" text={title} className={styles.deleteConfirmTitle} />
          <MotionText as="text" text={message} className={styles.deleteConfirmMessage} />
          <div className={styles.deleteConfirmActions}>
            <SystemButton
              variant="outlinedPrimarySkyBlue"
              onClick={onCancel}
              disabled={isDeleting}
              fullWidthButton
            >
              Cancel
            </SystemButton>
            <SystemButton
              variant="primaryDarkSkyBlue"
              onClick={onConfirm}
              disabled={isDeleting}
              fullWidthButton
            >
              {isDeleting ? 'Deleting...' : 'Delete'}
            </SystemButton>
          </div>
        </motion.div>
      </motion.div>
    )}
  </AnimatePresence>
);
